var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menuShow)?_c('div',{ref:"menu",staticClass:"rMenu",style:({ top: _vm.y + 'px', left: _vm.x + 'px' }),attrs:{"id":"menu"},on:{"mouseleave":_vm.closeMenu}},[_c('ul',_vm._l((_vm.data),function(m,i){return _c('li',{key:i,on:{"click":function($event){_vm.liClick(m), _vm.closeMenu()}}},[_vm._v(" "+_vm._s(m.optionName)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }